import { render, staticRenderFns } from "./GroupRender.vue?vue&type=template&id=51bff0c2&"
import script from "./GroupRender.vue?vue&type=script&lang=js&"
export * from "./GroupRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports